export default {
  MuiPaper: {
    styleOverrides: {
      root: {
        '& .MuiDataGrid-filterForm': {
          gap: '8px',
        },
        '& .MuiDataGrid-filterFormOperatorInput': {
          width: '190px',
        },
        '& .MuiDataGrid-filterFormValueInput': {
          width: '240px',
        },
        '& .MuiDataGrid-filterFormValueInput .MuiInputBase-root': {
          height: 'auto',
          minHeight: 36,
        },
        '& .MuiDataGrid-filterFormValueInput .MuiAutocomplete-input': {
          height: 'auto',
          padding: '4px 6px',
          minWidth: '80px !important',
        },
        '& .MuiDataGrid-filterFormColumnInput': {
          width: '180px',
        },
        '& .MuiDataGrid-columnsManagementHeader': {
          padding: '8px 18px 2px 18px',
        },
      },
    },
  },
};
